import React from "react";
import Login from "./components/Login";
import "./index.css";
import { Routes, Route } from "react-router-dom";
import Signup from "./components/register";

const App = () => {
  function disableDevtool() {
    document.addEventListener("contextmenu", (e) => e.preventDefault());
    function ctrlShiftKey(e, key) {
      return e.ctrlKey && e.shiftKey && e.key === key;
    }

    document.addEventListener("keydown", (e) => {
      if (
        e.key === "F12" ||
        ctrlShiftKey(e, "i") ||
        ctrlShiftKey(e, "I") ||
        ctrlShiftKey(e, "j") ||
        ctrlShiftKey(e, "J") ||
        ctrlShiftKey(e, "C") ||
        ctrlShiftKey(e, "c") ||
        (e.ctrlKey && e.key === "u")
      ) {
        e.preventDefault();
      }
    });
  }
  disableDevtool();

  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signin" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
    </div>
  );
};

export default App;
